__turbopack_context__.v({
  "icon": "_aBg5W_icon",
});
